import { dataService } from 'App';
import { FORM_MULTI_HEADERS_CONF } from 'utils/requestHelpers';

const infoServiceUrl='/users/phonebook';

export function updatePhonebook(data) {
  return dataService.post(
    `${infoServiceUrl}/updateRehber`,data
  );
}


export function onUploadFile(file) {
  let form = new FormData();
  form.append("file",file);
  return dataService.post(
    `${infoServiceUrl}?fields=MSISDN,NAME,EMAIL,BIRTHDATE,JOB`,form,FORM_MULTI_HEADERS_CONF
  );
}

export function getRecipients() {
  return dataService.get(
    `${infoServiceUrl}/recipients`
  );
}


export function uploadRecipients(data) {
  return dataService.post(
    `${infoServiceUrl}/updateRehber`,data
  );
}

export function resetList() {
  return dataService.post(
    `${infoServiceUrl}/resetlist`
  );
}